export default __webpack_public_path__ + "book_details-advanced_type_setting.319950e9.png";